:host {
  --aha-progress-bar--background: var(--theme-secondary-background);
  --aha-progress-bar--bar: var(--theme-green-background);
  --aha-progress-bar--counter-font-size: max(
    calc(var(--aha-progress-bar--height) * 0.625),
    var(--default-font-size)
  );
  display: flex;
  position: relative;
  border-radius: var(--Common--border-radius);
  background: var(--aha-progress-bar--background);
  background-clip: border-box;
  box-sizing: border-box;
  overflow: hidden;
}

#bar {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  min-width: 0.5%;
  background: var(--aha-progress-bar--bar);
  border-radius: inherit;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}
#text {
  position: relative;
  margin-left: 10px;
  margin-right: 10px;
  line-height: var(--aha-progress-bar--height);
  display: flex;
}
#counter {
  font-size: var(--aha-progress-bar--counter-font-size);
}
:host([no-text]) #text {
  visibility: hidden;
}
slot {
  font-size: var(--aha-progress-bar--font-size, --default-font-size);
}
slot::before {
  content: ' ';
  white-space: pre;
  font-size: var(--aha-progress-bar--counter-font-size);
}
